<div class="container-fluid container-fluid-5 d-none-mobile fancy-page">
  <div class="d-flex flex-wrap">
    <div class="col-md-2">
      <div class="facncy-provider">
        <div class="fancy-provider-title">
          <a><span>Providers</span> </a>
        </div>
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/4.png"
                />
                <span>Our Casino</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/19.png"
                />
                <span>Our Virtual</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/26.png"
                />
                <span>Tembo</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/24.png"
                />
                <span>Creedroomz</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/21.png"
                />
                <span>Vivo Gaming</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/17.png"
                />
                <span>Lucky Streak</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/5.png"
                />
                <span>Evolution</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/1.png"
                />
                <span>EZUGI</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/6.png"
                />
                <span>CockFight</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-10 tab-content">
      <div class="fancy-provider-title">
        <a><span>Our Casino</span></a>
      </div>
      <div class="casino-tabs">
        <div class="casino-tabs-menu">
          <!-- <a href="javascript:void(0)" class="arrow-tabs arrow-left"
            ><img
              src="https://wver.sprintstaticdata.com/v38/static/front/img/arrow-down.svg"
          /></a> -->
          <ul id="casino-scroll-tab" class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/35.png"
                />
                <span>All Casino</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/31.png"
                />
                <span>Roulette</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/20.png"
                />
                <span>Teenpatti</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/21.png"
                />
                <span>Poker</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/22.png"
                />
                <span>Baccarat</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/23.png"
                />
                <span>Dragon Tiger</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/24.png"
                />
                <span>32 Cards</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/26.png"
                />
                <span>Andar Bahar</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/27.png"
                />
                <span>Lucky 7</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/28.png"
                />
                <span>3 Card Judgement</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/29.png"
                />
                <span>Casino War</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/30.png"
                />
                <span>Worli</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/34.png"
                />
                <span>Sports</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/32.png"
                />
                <span>Bollywood</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/33.png"
                />
                <span>Lottery</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/40.png"
                />
                <span>Queen</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/41.png"
                />
                <span>Race</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/73.png"
                />
                <span>Others</span></a
              >
            </li>
          </ul>
          <!-- <a href="javascript:void(0)" class="arrow-tabs arrow-right"
            ><img
              src="https://wver.sprintstaticdata.com/v38/static/front/img/arrow-down.svg"
          /></a> -->
        </div>
      </div>
      <div class="tab-pane active">
        <div class="casino-banners">
          <!-- <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/ballbyball.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen33.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/sicbo.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen32.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a href="javascript:void(0)">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/roulette1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
          <div class="casino-banner-item">
            <a routerLink="/dashboard/teenpattioneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/teen-patti20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/teenpattitest" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen9.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/teenpattiopen" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen8.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <!-- <div class="casino-banner-item"  *ngIf="game == 'poker' || game == 'all'">
            <a routerLink="/dashboard/pokeroneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div> -->
          <div
            class="casino-banner-item"
            *ngIf="game == 'poker' || game == 'all'"
          >
            <a routerLink="/dashboard/pokert20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'poker' || game == 'all'"
          >
            <a routerLink="/dashboard/poker6" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker6.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'baccarat' || game == 'all'"
          >
            <a routerLink="/dashboard/baccarat1" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/baccarat.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'baccarat' || game == 'all'"
          >
            <a routerLink="/dashboard/baccarat2" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/baccarat2.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/dragontigert20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/dragontigeroneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt6.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/dragontigerliont20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dtl20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/dragontigert202" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt202.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/card32a" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/card32.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/card32b" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/card32eu.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/andarbahar" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/ab20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/andarbahar2" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/abj.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/lucky7" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/lucky7.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item">
            <a routerLink="/dashboard/lucky7b" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/lucky7eu.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <!-- <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/3cardj.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/war.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/worli.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/worli2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
          <div class="casino-banner-item">
            <a routerLink="/dashboard/aaa" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/aaa.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <!--<div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/btable.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/lottcard.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cricketv3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmatch20.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmeter.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen6.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/queen.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race20.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/lucky7eu2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/superover.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/trap.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/patti2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teensin.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teenmuf.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race17.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen20b.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/trio.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/notenum.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/kbc.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen120.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a >
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/roulette.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/ab3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/aaa2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/dum10.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmeter1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid container-fluid-5 d-none-desktop fancy-page">
  <div class="">
    <div class="">
      <div class="facncy-provider">
        <div class="fancy-provider-title">
          <a><span>Providers</span> </a>
        </div>
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/4.png"
                />
                <span>Our Casino</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/19.png"
                />
                <span>Our Virtual</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/26.png"
                />
                <span>Tembo</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/24.png"
                />
                <span>Creedroomz</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/21.png"
                />
                <span>Vivo Gaming</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/17.png"
                />
                <span>Lucky Streak</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/5.png"
                />
                <span>Evolution</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/1.png"
                />
                <span>EZUGI</span>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <div>
                <img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/icons/6.png"
                />
                <span>CockFight</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="fancy-provider-title">
        <a><span>Our Casino</span></a>
      </div>
      <div class="casino-tabs">
        <div class="casino-tabs-menu">
          <!-- <a href="javascript:void(0)" class="arrow-tabs arrow-left"
            ><img
              src="https://wver.sprintstaticdata.com/v38/static/front/img/arrow-down.svg"
          /></a> -->
          <ul id="casino-scroll-tab" class="nav nav-tabs">
            <li class="nav-item" (click)="setGame('all')">
              <a class="nav-link" [class.active]="game == 'all'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/35.png"
                />
                <span>All Casino</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/31.png"
                />
                <span>Roulette</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('teen')">
              <a class="nav-link" [class.active]="game == 'teen'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/20.png"
                />
                <span>Teenpatti</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('poker')">
              <a class="nav-link" [class.active]="game == 'poker'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/21.png"
                />
                <span>Poker</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('baccarat')">
              <a class="nav-link" [class.active]="game == 'baccarat'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/22.png"
                />
                <span>Baccarat</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('dt')">
              <a class="nav-link" [class.active]="game == 'dt'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/23.png"
                />
                <span>Dragon Tiger</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('card32')">
              <a class="nav-link" [class.active]="game == 'card32'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/24.png"
                />
                <span>32 Cards</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('ab')">
              <a class="nav-link" [class.active]="game == 'ab'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/26.png"
                />
                <span>Andar Bahar</span></a
              >
            </li>
            <li class="nav-item" (click)="setGame('lucky')">
              <a class="nav-link" [class.active]="game == 'lucky'"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/27.png"
                />
                <span>Lucky 7</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/28.png"
                />
                <span>3 Card Judgement</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/29.png"
                />
                <span>Casino War</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/30.png"
                />
                <span>Worli</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/34.png"
                />
                <span>Sports</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/32.png"
                />
                <span>Bollywood</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/33.png"
                />
                <span>Lottery</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/40.png"
                />
                <span>Queen</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/41.png"
                />
                <span>Race</span></a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link"
                ><img
                  src="https://wver.sprintstaticdata.com/v38/static/front/img/casino-tab-icons/4/73.png"
                />
                <span>Others</span></a
              >
            </li>
          </ul>
          <!-- <a href="javascript:void(0)" class="arrow-tabs arrow-right"
            ><img
              src="https://wver.sprintstaticdata.com/v38/static/front/img/arrow-down.svg"
          /></a> -->
        </div>
      </div>
      <div class="tab-pane active">
        <div class="casino-banners">
          <!-- <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/ballbyball.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen33.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/sicbo.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen32.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a href="javascript:void(0)">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/roulette1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
          <div
            class="casino-banner-item"
            *ngIf="game == 'teen' || game == 'all'"
          >
            <a routerLink="/dashboard/teenpattioneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'teen' || game == 'all'"
          >
            <a routerLink="/dashboard/teen-patti20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'teen' || game == 'all'"
          >
            <a routerLink="/dashboard/teenpattitest" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen9.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'teen' || game == 'all'"
          >
            <a routerLink="/dashboard/teenpattiopen" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/teen8.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'poker' || game == 'all'"
          >
            <a routerLink="/dashboard/pokeroneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'poker' || game == 'all'"
          >
            <a routerLink="/dashboard/pokert20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'poker' || game == 'all'"
          >
            <a routerLink="/dashboard/poker6" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/poker6.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'baccarat' || game == 'all'"
          >
            <a routerLink="/dashboard/baccarat1" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/baccarat.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'baccarat' || game == 'all'"
          >
            <a routerLink="/dashboard/baccarat2" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/baccarat2.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'dt' || game == 'all'">
            <a routerLink="/dashboard/dragontigert20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'dt' || game == 'all'">
            <a routerLink="/dashboard/dragontigeroneday" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt6.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'dt' || game == 'all'">
            <a routerLink="/dashboard/dragontigerliont20" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dtl20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'dt' || game == 'all'">
            <a routerLink="/dashboard/dragontigert202" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/dt202.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'card32' || game == 'all'"
          >
            <a routerLink="/dashboard/card32a" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/card32.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'card32' || game == 'all'"
          >
            <a routerLink="/dashboard/card32b" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/card32eu.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'ab' || game == 'all'">
            <a routerLink="/dashboard/andarbahar" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/ab20.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div class="casino-banner-item" *ngIf="game == 'ab' || game == 'all'">
            <a routerLink="/dashboard/andarbahar2" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/abj.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'lucky' || game == 'all'"
          >
            <a routerLink="/dashboard/lucky7" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/lucky7.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <div
            class="casino-banner-item"
            *ngIf="game == 'lucky' || game == 'all'"
          >
            <a routerLink="/dashboard/lucky7b" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/lucky7eu.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <!-- <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/3cardj.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/war.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/worli.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/worli2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
          <div
            class="casino-banner-item"
            *ngIf="game == 'aaa' || game == 'all'"
          >
            <a routerLink="/dashboard/aaa" class="">
              <div
                style="
                  background-size: cover;
                  background-position: center center;
                  padding-top: 53.33%;
                  background-image: url('https://sitethemedata.com/casino_icons/lc/aaa.jpg'),
                    url('https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg');
                "
              ></div>
            </a>
          </div>
          <!--<div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/btable.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/lottcard.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cricketv3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmatch20.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmeter.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen6.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/queen.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race20.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/lucky7eu2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/superover.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/trap.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/patti2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teensin.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teenmuf.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race17.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen20b.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/trio.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/notenum.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/kbc.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen120.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a >
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/roulette.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/ab3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/aaa2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/race2.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/teen3.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/dum10.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div>
              <div class="casino-banner-item">
                 <a  class="">
                    <div style="background-size: cover; background-position: center center; padding-top: 53.33%; background-image: url(&quot;https://sitethemedata.com/casino_icons/lc/cmeter1.jpg&quot;), url(&quot;https://wver.sprintstaticdata.com/v38/static/front/img/casino/default-2.jpeg&quot;);"></div>
                 </a>
              </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
